module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_5_3.8966f832.png";